<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'nuxt/app'

  import { isCPAuthRoutePath } from '@clientportal/routing-layer/utils/auth-route.utils'

  import CPRootContainer from './components/CPRootContainer.vue'

  const route = useRoute()

  const layoutBoundaryKey = computed(() => (isCPAuthRoutePath(route.path) ? 'auth' : 'portal'))
</script>

<template>
  <CPRootContainer>
    <NuxtLayout :key="layoutBoundaryKey">
      <NuxtPage />
    </NuxtLayout>
  </CPRootContainer>
</template>
